// extracted by mini-css-extract-plugin
module.exports = {"pdfContainer":"receipts_pdfContainer__12Edh","secondary":"receipts_secondary__3C4Lh","tableHeader":"receipts_tableHeader__1NLlM"};